(function($) {

    // Toggle share popup
    $('#shareToggle').on('click', function(e) {
        e.stopPropagation();
        $this = $(this);

        // Adds active class
        if($this.hasClass('is-active')) {
            $this.removeClass('is-active');
            $this
                .closest('.share-popup')
                .find('.share-list')
                .removeClass('is-active');

        } else {
            $this.addClass('is-active');
            $this
                .closest('.share-popup')
                .find('.share-list')
                .addClass('is-active');
        }

    });

    $('.product-sharing button').on('click', function(e){
      e.preventDefault();
      let $parent = $(this).parent('.product-sharing');
      $parent.toggleClass('is-active');
      if ($parent.hasClass('is-active')) {
        $('.product-sharing .menu a').first().focus();
      }
    });

    $('body').on('keyup', function(e){
        // keyCode is getting deprecated use key instead when supported, which makes this messy
        evt = e || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key == "Escape" || evt.key == "Esc");
        } else {
            isEscape = (evt.keyCode == 27);
        }
        if (isEscape) {
          $('.product-sharing').removeClass('is-active');
        }
    });

})(jQuery);
